import Axios, { AxiosRequestConfig } from 'axios'
import common from '@/api/modules/common'
import mainConfig from './server_config/main'
import store from '@/store/index'
// console.log(common)
const modules = [common]
// console.log(modules)
class Fetch {
    public post<T>(data: {
        url: string,
        params?: any
    }): Promise<T | any> {
        const serverConfig = {
            url: data.url,
            method: 'post',
            headers: {
                "Authentication": (store.state as any).shop.token,
                "ShopAuthentication": localStorage.getItem('shopId'),
                'LS-Source': 'Web'
            },
            data: data.params // qs.stringify(data.params)
        }
        return this.getData(Object.assign({}, mainConfig, serverConfig))
    }

    private getData(config: any) {
        console.log(config)
        const instance = Axios.create(config)

        // 添加单次请求的拦截器
        instance.interceptors.request.use(...config.reqInterceptor)
        instance.interceptors.response.use(...config.repInterceptor)

        return instance.request(config)
    }
}

const $fetch = new Fetch()

export default $fetch

export {
    $fetch
}
